import React from 'react'
import StudentLayerList from '../components/student/StudentLayerList'
import MasterLayout from '../masterLayout/MasterLayout'
    
function StudentPageList() {
    return (
        <MasterLayout>
        <StudentLayerList />    
        </MasterLayout>
    )
}

export default StudentPageList